import { PropType, defineComponent } from "vue";
import { Flow } from "@mv/flow-shared-utils/types/flow";

export default defineComponent({
  name: "sdk-flow-definition-card",
  components: {
    "sdk-flow-bpmn-viewer": () => import("@/components/sdk-flow-bpmn-viewer/sdk-flow-bpmn-viewer.vue"),
    "sdk-flow-instance-starter": () => import("@/components/sdk-flow-instance-starter/sdk-flow-instance-starter.vue"),
  },
  props: {
    definition: {
      type: Object as PropType<Flow.Process.Definition.definition>,
      required: true,
    },
    xml: String,
  },
  computed: {
    routeParameters(): { [key: string]: string } {
      return {
        definitionId: this.definition.id as string,
        categoryId: this.$route.params.categoryId || (this.definition.category as any).id,
        definitionKey: this.definition.key,
      };
    },
  },
});
